import { IconChevronDown, IconChevronRight } from '@tabler/icons-react';
import { ColumnDef, Row } from '@tanstack/react-table';

import { ListingWithBids } from './BidsTab';
import { FIELD_CONFIG } from '../../../../configs/columns';
import { SellerDealsWithCarves_user_company_deals } from '../../../../query/__generated__/SellerDealsWithCarves';
import { WithSubData } from '../../../../ui-kit';
import { formatCentsToDollars, toPercentage } from '../BiddingAndPricing/formatting';

export type DealsWithCarves_user_company = SellerDealsWithCarves_user_company_deals & {
  __typename: string;
};

export const activeTradesBidsListingColsOrder = [
  'selection',
  'icons',
  'listing.providedName',

  'createdDate',
  'listing.assetClass',
  'listing.upb',
  'listing.loan_count',
  'listing.wa_coupon_bps',
  'listing.wa_loan_age_months',
  'listing.wa_remaining_loan_terms_months',
  'listing.wa_borrower_credit_score',
  'listing.wa_ltv_bps',
];

type RowIconsProps = {
  row: Row<WithSubData<ListingWithBids>>;
};

const RowIcon = (props: RowIconsProps) => {
  const isExpanded = props.row.getIsExpanded();
  const Icon = isExpanded ? IconChevronDown : IconChevronRight;
  return (
    <span className="flex cursor-pointer flex-row items-center justify-start [&>*]:mr-[5px]">
      {props.row.getCanExpand() && <Icon />}
    </span>
  );
};

export const bidsColumnDefinitions: ColumnDef<WithSubData<ListingWithBids>>[] = [
  {
    id: 'icons',
    cell: (props) => {
      return <RowIcon row={props.row} />;
    },
    meta: {
      headerNoPill: true,
    },
  },
  {
    header: 'Loan Pool Name',
    id: 'listing.providedName',
    accessorKey: 'listing.providedName',
  },

  {
    header: 'Date Created',
    id: 'createdDate',
    accessorKey: 'listing.createdDate',
    cell: (props) => {
      return <span>{FIELD_CONFIG.maturity_date.display(props.getValue() as string)}</span>;
    },
  },
  {
    header: 'Asset Class',
    id: 'listing.assetClass',
    accessorKey: 'listing.assetClass',
    cell: (props) => <span>{String(props.getValue() === 'HOME' ? 'RESI' : props.getValue())}</span>,
  },
  {
    header: 'UPB',
    id: 'listing.upb',
    accessorKey: 'listing.upb',
    cell: (props) => <span>{formatCentsToDollars(Number(props.getValue()))}</span>,
  },
  {
    header: '# Loans',
    id: 'listing.loan_count',
    accessorKey: 'listing.loan_count',
  },
  {
    header: 'GWAC',
    id: 'listing.wa_coupon_bps',
    accessorKey: 'listing.wa_coupon_bps',
    cell: (props) => <span>{toPercentage(Number(props.getValue()))}</span>,
  },
  {
    id: 'listing.wa_loan_age_months',
    accessorKey: 'listing.wa_loan_age_months',
    header: 'WALA',
    meta: {
      numeric: true,
    },
  },
  {
    accessorKey: 'listing.wa_remaining_loan_terms_months',
    id: 'listing.wa_remaining_loan_terms_months',
    header: 'WAM',
    meta: {
      numeric: true,
    },
  },
  {
    accessorKey: 'listing.wa_borrower_credit_score',
    id: 'listing.wa_borrower_credit_score',
    header: 'FICO',
    meta: {
      numeric: true,
    },
  },
  {
    accessorKey: 'listing.wa_ltv_bps',
    id: 'listing.wa_ltv_bps',
    header: 'LTV',
    cell: (props) => <span>{toPercentage(Number(props.getValue()))}</span>,
    meta: {
      numeric: true,
    },
  },
];
